import { Message } from 'lib-shared-legacy-types';
import type { SearchConversationHit } from 'lib-shared-types-api';

import TextMessage from 'components/conversation/components/messages/TextMessage';
import { useAppSelector } from 'utils/redux/useAppSelector';

import {
  isMessageSupported,
  SupportedMessage,
} from '../../utils/conversationPreviewDefinitions';

import styles from './conversationPreviewMessages.module.scss';

type ConversationPreviewMessagesProps = {
  messages: Array<Readonly<Message | SupportedMessage>>;
  innerHits?: SearchConversationHit['_inner_hits'];
  requesterId: string | null | undefined;
};

export const ConversationPreviewMessages = ({
  messages,
  innerHits = [],
  requesterId,
}: ConversationPreviewMessagesProps): JSX.Element => {
  const currentUserId = useAppSelector(
    (state) => state.settings.profile.profile.id,
  );

  const supportedMessages = messages.filter(isMessageSupported);
  const listIsEmpty = supportedMessages.length === 0;

  return (
    <div className={styles.root}>
      {listIsEmpty ? (
        <div>This conversation has no messages.</div>
      ) : (
        supportedMessages.map((_message: Readonly<SupportedMessage>, index) => {
          const message = { ..._message };
          const own = message.author?.id === currentUserId;
          const isAgent = message.author?.id !== requesterId;
          const internal = message.type === 'conversation:wrapup_message';

          if (innerHits) {
            innerHits.map((hit) => {
              if (hit.highlight?.text && hit.id === message.id) {
                message.text = hit.highlight.text;
              }
            });
          }

          return (
            <TextMessage
              key={message.id || index}
              own={own}
              isAgent={isAgent}
              internal={internal}
              message={message}
              author={message.author}
              date={message.created_at || ''}
            />
          );
        })
      )}
    </div>
  );
};
